<i18n lang='yml' src='../i18n/ExamTypeView.yml'></i18n>
<template>
  <div>
    <div class="layout-tile">
      <div class="heading-block d-flex">
        <h4>
          {{ $t('view_exam_type') }}
        </h4>
      </div>
      <div class="media-body">
        <h5 class="">{{ `${$t('exam_type')} - ${examTypeRecord.name[locale]}`}}</h5>
        <div class="content-block">
          <div class="post-meta">
            <div class="action-bar border-bottom mb-4">
              <h4> {{$t('exam_type_details')}} </h4>
              <div class="btn-group btn-group-xs ml-auto" role="group" v-if="edit_permission == 'true'">
                <a class="btn btn-sm btn-outline-primary" :href="`${base_path}/${examTypeRecord.id}/edit`">                                         
                  <font-awesome-icon :icon="['fa', 'pencil-alt']" />
                  {{ $t('edit') }}
                </a>
              </div>
            </div>
            <ul class="exam-details my-4">
              <li>
                <span class="status-bold">
                  {{$t('name_en')}}
                </span>
                {{ examTypeRecord.name.en }}
              </li>
              <li>
                <span class="status-bold">
                  {{$t('name_fr')}}
                </span>
                {{ examTypeRecord.name.fr }}
              </li>
              <li>
                <span class="status-bold">
                  {{$t('max_retries')}}
                </span>
                {{examTypeRecord.max_retries}}
              </li>
              <li>
                <span class="status-bold">
                  {{$t('time_between_retries')}}
                </span>
                {{examTypeRecord.time_between_retries}}
              </li>
         
              <li>
                <span class="status-bold">
                  {{$t('pass_mark')}}
                </span>
                  {{examTypeRecord.pass_mark}}
              </li>
            
              <!-- <li>
                <span class="status-bold">
                  {{$t('current_fee')}}
                </span>
                  {{examTypeRecord.current_fee}}
              </li> -->

              <!-- Commenting this for now as apparently STO doesn't use it at the moment but leaving it in just in case they want it again -->
              <!-- <li>
                <span class="status-bold">
                  {{$t('scheduled_online')}}
                </span>
                {{examTypeRecord.scheduled_online? $t('yes_val') : $t('no_val')}}
              </li> -->

               <li>
                <span class="status-bold">
                  {{$t('inventory_required')}}
                </span> 
                {{examTypeRecord.inventory_required? $t('yes_val') : $t('no_val')}} 
              </li>

              <li>
                <span class="status-bold">
                  {{$t('required_resources')}}
                </span>
                {{examTypeRecord.required_resources}}
              </li>
                                                                                                          
              <li>
                <span class="status-bold">
                  {{$t('time_allowance')}}
                </span>
                   {{examTypeRecord.time_allowance}}
              </li>
      
              <li>
                <span class="status-bold">
                  {{$t('number_of_questions')}}
                </span>
                {{examTypeRecord.number_of_questions}}
              </li>
              <li>
                <span class="status-bold">
                  {{$t('visible_to_exam_challengers')}}
                </span>
                {{examTypeRecord.visible_to_challengers? $t('yes_val') : $t('no_val')}}

              </li>

              <li>
                <span class="status-bold"> {{$t('status')}} </span> 
                <span v-if="examTypeRecord.status">{{ $t(examTypeRecord.status) }} </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {                                                                                              
    props: ['locale', 'exam_type', 'base_path', 'edit_permission'],
    data() {
      return {
        loading: true,
        examTypeRecord: {
          name: {}
        }
      }
    },
    mounted () {
      this.loading = false
      this.$i18n.locale = this.locale;
      try {
        this.examTypeRecord = JSON.parse(this.exam_type)
        if(this.examTypeRecord.name == null){
          this.examTypeRecord.name = {}
        }
      }
      catch(err) {
        this.error = true; 
      } 
    },
  }
</script>
